/**
 * Fantasy Console 0 - Playback Controls Component
 *
 * Play/Stop/Play Loop buttons for SFX preview.
 */

import styles from './PlaybackControls.module.css'

interface PlaybackControlsProps {
  isPlaying: boolean
  hasLoop: boolean
  onPlay: () => void
  onPlayLoop: () => void
  onStop: () => void
}

export function PlaybackControls({
  isPlaying,
  hasLoop,
  onPlay,
  onPlayLoop,
  onStop,
}: PlaybackControlsProps) {
  return (
    <div className={styles.container}>
      <button
        className={`${styles.button} ${!isPlaying ? styles.active : ''}`}
        onClick={onPlay}
        disabled={isPlaying}
        title='Play (Space)'
      >
        <svg width='14' height='14' viewBox='0 0 14 14' fill='currentColor'>
          <path d='M3 2v10l9-5z' />
        </svg>
        Play
      </button>
      <button
        className={`${styles.button} ${!isPlaying ? styles.active : ''}`}
        onClick={onPlayLoop}
        disabled={isPlaying || !hasLoop}
        title='Play from loop start'
      >
        <svg width='14' height='14' viewBox='0 0 14 14' fill='currentColor'>
          <path d='M3 2v10l6-5z' />
          <rect x='10' y='3' width='2' height='8' rx='0.5' />
        </svg>
        Loop
      </button>
      <button
        className={`${styles.button} ${isPlaying ? styles.active : ''}`}
        onClick={onStop}
        disabled={!isPlaying}
        title='Stop (Space)'
      >
        <svg width='14' height='14' viewBox='0 0 14 14' fill='currentColor'>
          <rect x='3' y='3' width='8' height='8' rx='1' />
        </svg>
        Stop
      </button>
    </div>
  )
}
